var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6C21 5.45228 20.5477 5 20 5H4C3.45228 5 3 5.45228 3 6V18C3 18.5477 3.45228 19 4 19H20C20.5477 19 21 18.5477 21 18V6ZM23 18C23 19.6523 21.6523 21 20 21H4C2.34772 21 1 19.6523 1 18V6C1 4.34772 2.34772 3 4 3H20C21.6523 3 23 4.34772 23 6V18Z",
    fill: "#8F93A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4267 5.18065C21.8792 4.86411 22.5027 4.97436 22.8193 5.42675C23.1359 5.87918 23.0256 6.50266 22.5732 6.81933L12.5732 13.8193C12.229 14.0602 11.771 14.0602 11.4267 13.8193L1.42675 6.81933C0.974364 6.50266 0.864109 5.87918 1.18065 5.42675C1.49732 4.97436 2.1208 4.86411 2.57323 5.18065L12 11.7793L21.4267 5.18065Z",
    fill: "#8F93A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b8c395477771107172213c9687db2986.svg";
export { ForwardRef as ReactComponent };